import React from 'react';

import {Grid} from '@mui/material';

import DefectCountByPartChart from './components/DefectCountByPartChart';
import LastExecutionResultPanel from './components/LastExecutionResultPanel';
import PerformanceAndDefectRateChart from './components/PerformanceAndDefectRateChart';
import TodaySummaryPanel from './components/TodaySummaryPanel';
import {SearchConditions} from './types';

interface MainPanelProps {
  searchConditions: SearchConditions | null;
  setDelay: React.Dispatch<React.SetStateAction<number | null>>;
}

export const MainPanel = (props: MainPanelProps) => {
  return props.searchConditions ? (
    <Grid container spacing={1}>
      <Grid item xs={12} md={5} lg={4} xl={3}>
        <TodaySummaryPanel searchConditions={props.searchConditions} />
      </Grid>
      <Grid item xs={12} md={7} lg={8} xl={9} mt={3}>
        <Grid container spacing={1}>
          <Grid item xs={12} lg={6}>
            <PerformanceAndDefectRateChart searchConditions={props.searchConditions} />
          </Grid>
          <Grid item xs={12} lg={6}>
            <DefectCountByPartChart searchConditions={props.searchConditions} />
          </Grid>
          <Grid item xs={12}>
            <LastExecutionResultPanel
              searchConditions={props.searchConditions}
              setDelay={props.setDelay}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  ) : null;
};
